// Angular
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

// Custom
import { UtilsService } from '../utils/utils.service';
import { WebService } from '../web/web.service';

// Other
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  private loginUrl = environment.apiUrlWOVersion + 'favoriotadmin/authenticate';
  private resetPassUrl = environment.apiUrlWOVersion + 'auth/forgot';
  private resetUrl = environment.apiUrlWOVersion + 'auth/reset';

  constructor(private http: HttpClient, private utils: UtilsService, private web: WebService) { }

  // logs in the admin user
  public loginAdmin(adminUser) {
    return this.http.post(this.loginUrl, this.utils.stringifyObject(adminUser), { headers: this.web.generateHeaders() })
      .toPromise()
      .then(processData)
      .catch(handleErrors);
  }

  // request password
  public requestForPasswordReset(email) {
    return this.http.post(this.resetPassUrl, this.utils.stringifyObject(email), { headers: this.web.generateHeaders() })
      .toPromise()
      .then(processData)
      .catch(handleErrors);
  }

  // reset password
  public resetPassword(resetObj) {
    return this.http.post(this.resetUrl, this.utils.stringifyObject(resetObj), { headers: this.web.generateHeaders() })
      .toPromise()
      .then(processData)
      .catch(handleErrors);
  }
}

// process data for login
function processData(res) {
  if (res.statusCode === 200) {
    // save to local storage
    localStorage.setItem('user', JSON.stringify(res.message));
    return Promise.resolve('User authenticated');
  } else if (res.statusCode === 20000) {
    return Promise.resolve(res.message);
  } else if (res.statusCode === 20101) {
    return Promise.resolve(res.message);
  }
}

// process any errors got from error
function handleErrors(errors) {
  console.log(errors);
  return Promise.reject(errors.error.message || 'Server error');
}